var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { width: "400", persistent: "" },
          model: {
            value: _vm.UploadStatusDialog,
            callback: function($$v) {
              _vm.UploadStatusDialog = $$v
            },
            expression: "UploadStatusDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                {
                  staticClass: "headline p-10 elc-clubdetails-dialog-header",
                  attrs: { "primary-title": "" }
                },
                [_vm._v("\n                Upload Status\n            ")]
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _c(
                  "p",
                  { staticStyle: { "font-size": "18px", color: "#477314" } },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.successArr.length) +
                        " records imported successfully.\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.failArr.length > 0
                  ? _c("div", [
                      _c(
                        "p",
                        { staticStyle: { "font-size": "18px", margin: "0" } },
                        [
                          _vm._v(
                            _vm._s(_vm.failArr.length) + " records failed."
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        _vm._l(_vm.failArr, function(record) {
                          return _c(
                            "li",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                color: "#ff4d4d"
                              }
                            },
                            [_vm._v(_vm._s(record))]
                          )
                        })
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "elc-button-radius-color",
                      on: { click: _vm.cancel }
                    },
                    [_vm._v("OK")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35ca03bf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35ca03bf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/UploadStatusDialog.vue
// module id = null
// module chunks = 